

export class ClassificationDto {
  _id: string;
  Title: string;

  Price: number;
  PropertyId: string;
  Pictures:
    [{
      PictureUrl: string,
      path: string,

    }];
  Description: string;
  id: string;

}
